import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Icon } from '~/components/atomic';

interface NavigateButtonProps {
  viewState: boolean;
  windowWidth: number;
  handleNavigateClick: () => void;
}

export default function NavigateButton({
  viewState,
  windowWidth,
  handleNavigateClick,
}: NavigateButtonProps) {
  if (!viewState) return null;

  return (
    <Container
      windowWidth={windowWidth}
      onClick={handleNavigateClick}
      className='top_button_test'
    >
      <Wrapper>
        <IconWrapper>
          <Icon iconName='ArrowUp' size={20} color='content_dark_1' />
        </IconWrapper>
      </Wrapper>
    </Container>
  );
}

const Container = styled.div<{ windowWidth: number }>`
  ${({ theme, windowWidth }) => css`
    position: fixed;
    z-index: 50;
    right: calc(50% - (${windowWidth}px / 2) + ${theme.layout.section_side});
    bottom: calc(${theme.layout.chat_navigation_height} + 17px);
  `}
`;

const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: ${theme.backgroundColor.bg_light_3_alpha};
  `}
`;

const IconWrapper = styled.button`
  display: block;
`;
